// todo: Собрать все продукты по проекту и положить в одно место - сюда
// todo: Добавить ссылку на документацию по productId
export enum EProductsId {
    internet = 5,
    internetCorporat = 7,
    tv = 53,
    ktv = 12,
    ktvPersonal = 19,
    telephony = 31,
    content = 67,
    domofon = 75,
    videoControl = 112,
    others = 0,
}
